import {linearEvents} from '../../../../tracker';
import {startMutedPosition} from './isSoundAllowed';

const {unmute, mute} = linearEvents;
const createDefaultSoundButton = () => {
  const soundButton = document.createElement('BUTTON');

  soundButton.type = 'button';
  soundButton.classList.add('sound-button');
  soundButton.classList.add('muted-button');

  return soundButton;
};

const onSound = (videoAdContainer, callback, {skipoffset, createSoundButton = createDefaultSoundButton} = {}) => {

  let soundControl;

  const {
    videoElement,
    element
  } = videoAdContainer;

 soundControl = createSoundButton();

 videoElement.volume = 1;
 if(!startMutedPosition.muted) soundControl.classList.remove('muted-button');

  soundControl.onclick = (event) => {
    if (Event.prototype.stopPropagation !== undefined) {
      event.stopPropagation();
    }
    videoElement.muted = !videoElement.muted;
    videoElement.muted ? videoElement.volume = 0 : videoElement.volume = 1;
    soundControl.classList.toggle('muted-button');
    videoElement.muted ? callback(mute) : callback(unmute);
    return false;
  };

  element.appendChild(soundControl);

};

export default onSound;
